import { client } from '@/api/client'

/** What the statistics endpoint on capi answers (#6361). */
type Statistics = {
  amount_of_calculations: number
}

/**
 * The number of calculations the tool has made, through the proxy route on the corporate website
 * like every other call. Fetched once when the tool loads: the line it feeds sits on the input
 * step, before the visitor calculates anything.
 *
 * Null when the answer carries no usable number: the line about the households then stays away,
 * instead of claiming "Al NaN huishoudens".
 */
export async function requestCalculationCount(): Promise<number | null> {
  const response = await client.get<Statistics>('/api/net-metering/statistics/')
  // Typed as unknown on purpose: the shape above is what capi promises, and a body from anything
  // else on the way (the proxy, an error page) carries whatever it likes.
  const count: unknown = response.data?.amount_of_calculations

  return typeof count === 'number' && Number.isFinite(count) ? count : null
}
